<template>
  <div class="wrapper">
    <div class="tabs">
      <div
        class="tab"
        v-for="(item,index) in tabs"
        :key="index"
        :class="{'active': activeIndex == item.type}"
        @click="showList(item)"
      >{{item.title}}</div>
    </div>
    <div class="list-box">
			<div class="list-item" v-for="item in list" :key="item.display" @click="handJump(item)">
				<div class="name-tit">
					<div class="name">
						<img v-if="item.logo_url" :src="item.logo_url" />
						{{ item.title }}
					</div>
					<div class="des">{{ item.ctime }}</div>
				</div>
				<div class="content">
					<img v-if="item.cover_img" :src="item.cover_img" />
					<div class="con ellipsis-line3">{{ item.content }}</div>
				</div>
			</div>
		</div>
		<div class="no-data" v-if="!list.length">
			<img src="../../assets/images/nomail.png" />
			<div>暂无消息内容</div>
		</div>
		<template v-if="list.length>0">
		  <Pagination :totalPage="totalPage" :limit="limit" @changePage="handOrderMore"></Pagination>
		</template>
  </div>
</template>

<script>
	import Pagination from "@/components/common/Pagination.vue";
	export default {
		name: 'Mail',
		components: { Pagination },
		data() {
			return {
				tabs: [
					{
					  type: 1,
					  title: this.$t('sysmail'),
					  display:"system"
					},
					{
					  type: 2,
					  title: this.$t('ordermail'),
					  display:"order"
					},
					{
					  type: 3,
					  title: this.$t('mymail'),
					  display:"private"
					}
				],
				activeIndex: 1,
				display:"system",
				list: [],
				page: 1,
				limit: 10,
				totalPage: 0
			}
		},
		mounted() {
			if (this.$storage.get("userToken")) {
				this.getMailList();
			}else{
				this.$router.push({
				    path: '/login'
				})
			}
		},
		methods: {
			handJump(data) {
				// if(data.click_type == 'intent'|| data.click_type == 'payload') {
				// 	this.$router.push(data.pclink);
				// }
				// if(data.click_type == 'url') {
				// 	window.location.href = data.pclink
				// }
				if(data.pclink) {
					if(data.pclink.indexOf('http') != -1) {
						window.location.href = data.pclink
					}else{
						this.$router.push(data.pclink);
					}
				}
			},
			showList(item) {
			  this.activeIndex = item.type;
			  this.display=item.display;
			  this.getMailList()
			},
			handOrderMore(val) {
			  this.page = val;
			  this.getMailList();
			},
			getMailList() {
				let data = {
					type_code: this.display,
					page: this.page,
					limit: this.limit
				}
				this.$api.getMessageList(data).then(res => {
				  if (res.status) {
				    this.list = res.data.list;
						this.totalPage = Math.ceil(
						  Number(res.data.count) / Number(this.limit)
						);
				  }
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import "@/assets/css/variable.scss";
	.coupon-wrap{
	  width: 280px;
	  margin:0 20px 20px 0;
	}
	.tabs {
	  display: flex;
	  border-bottom: 1px solid $border;
	  padding: 20px 0;
	  margin-bottom: 20px;
	  .tab {
	    padding: 0 20px;
	    color: #757575;
	    cursor: pointer;
	    &:hover {
	      color: #333;
	    }
	    &.active {
	      color: $theme-color;
	    }
	    &:not(:last-of-type) {
	      border-right: 1px solid $border;
	    }
	  }
	}
	.no-data {
		text-align: center;
		margin-top: 85px;
		color: #6C7A85;
		font-size: 16px;
		>img {
			width: 250px;
			margin-bottom: 28px;
		}
	}
	.list-box {
		.list-item {
			border: 1px solid $border;
			margin-bottom: 20px;
			padding: 25px 22px;
			cursor: pointer;
			user-select: none;
			.name-tit {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 18px;
				.name {
					display: flex;
					align-items: center;
					>img {
						width: 18px;
						height: 18px;
						margin-right: 2px;
					}
				}
				.des {
					font-size: 14px;
					color: #6C7A85;
				}
			}
			.content {
				display: flex;
				margin-top: 14px;
				>img {
					width: 50px;
					height: 50px;
					flex-shrink: 0;
				}
				.con {
					margin-left: 4px;
					color: #6C7A85;
					font-size: 17px;
					flex: 1;
				}
				.ellipsis-line3 {
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 3;
				}
			}
		}
	}
</style>